module.exports = __webpack_public_path__ + "static/media/cover.63b0c910.svg";